import { Autocomplete, Center } from '@mantine/core';
import { IconSearch } from '@tabler/icons';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import capitalizeWord from '../../utility/capitalizeWord';
import ResultSearchComponent from '../searchbox/resultsearch-component';
import style from './jumbotron1Style.module.css';

const dataResultSearch = [
  {
    title: 'Jember',
  },
  {
    title: 'Situbondo',
  },
];

const JumboTron1 = (props) => {
  const { city } = props;
  return (
    <div className={`${style.jumbotron} jumbotron-fluid`}>
      <div className={`${style['input-container']} input-container`}>
        <Center>
          <Autocomplete
            pl={27}
            mt={45}
            disabled
            icon={<IconSearch color="#000" />}
            placeholder={capitalizeWord(city)}
            data={[]}
            size="xs"
            sx={{
              width: '60%',
              padding: 10,
              borderRadius: 20,
              background: 'white',
              '@media (max-width: 600px)': {
                borderRadius: 10,
              },
            }}
            transition="pop-top-left"
            transitionDuration={150}
            transitionTimingFunction="ease"
          />
        </Center>
      </div>
    </div>
  );
};

export default JumboTron1;
